<div class="flex map flex column align-center pb-0">
  <!--  <pre>{{locations |json}}</pre>-->
  <div class="title flex align-center mb-0" [ngClass]="{'location-title': !title}">
    <p *ngIf="!title">{{'Location.Locations' | translate}}</p>
    <p *ngIf="title">{{ title }}</p>
  </div>
  <div style="height: 400px; width: 100%" *ngIf="googleMapLoaded">
    <google-map [center]="{lat: +latitude, lng: +longitude }" [zoom]="zoom" [options]="{ scrollwheel: false }">
      <ng-container *ngIf="locations?.length">
        <app-map-overlay [latitude]="+location.latitude" [longitude]="+location.longitude" *ngFor="let location of locations">
          <div class="overlay">
            <div class="image" [class.active]="location.selected">
              <app-icon *ngIf="!location.selected" [name]="'map-marker'"></app-icon>
              <app-icon *ngIf="location.selected" [name]="'map-marker-active'"></app-icon>
            </div>
            <div *ngIf="location.selected" class="indicator"></div>
            <div *ngIf="location.selected" class="data flex column">
              <div class="title flex">
                <img *ngIf="location.isDefault" src="../../../../../assets/images/primary.svg" />
                <h3>{{location.title}}</h3>
              </div>
              <div class="city flex">
                <span>{{'Location.Labels.City' | translate}}</span>
                <p>{{location.city?.name}}</p>
              </div>
              <div class="location flex">
                <span>{{'Location.Labels.Location' | translate}}</span>
                <p>{{location.latitude + ', ' + location.longitude}}</p>
              </div>
              <div class="address flex">
                <span>{{'Location.Labels.Address' | translate}}</span>
                <p>{{location.address}}</p>
              </div>
            </div>
          </div>
        </app-map-overlay>
      </ng-container>
    </google-map>
  </div>

  <div class="locations flex column" *ngIf="enableLocationsView">
    <div class="location flex column" [class.active]="location.selected" *ngFor="let location of locations" (click)="onSelectLocation(location)">
      <div class="title flex justify-space-between">
        <div class="flex">
          <img *ngIf="location.isDefault" src="../../../../../assets/images/primary.svg" />
          <h3>{{location.title}}</h3>
        </div>
        <div
          *ngIf="(type == LocationType.Customer && (RolesConstants.CUSTOMER_EDIT | userRoleChecker)) || (type == LocationType.Fleet && (RolesConstants.FLEET_EDIT | userRoleChecker)) || (type == LocationType.Receiver && (RolesConstants.GLOBAL_RECEIVER_EDIT | userRoleChecker))"
          class="menu flex"
        >
        <app-icon name="menu-vert"  class="cursor-pointer text-700" [matMenuTriggerFor]="menu"></app-icon>
          <mat-menu class="item-actions" #menu>
            <mat-option (click)="onSetAsDefault(location)">
              <span>{{ "Location.SetAsDefault" | translate }}</span>
            </mat-option>
            <mat-option (click)="onSelectLocation(location); matDialog.open(addLocationModal)">
              <span>{{ "Buttons.Edit" | translate }}</span>
            </mat-option>
          </mat-menu>
        </div>
      </div>
      <div class="city flex column">
        <span>{{'Location.Labels.City' | translate}}</span>
        <p>{{location.city?.name}}</p>
      </div>
      <div class="lat flex column">
        <span>{{'Location.Labels.Location' | translate}}</span>
        <p>{{location.latitude + ',' + location.longitude}}</p>
      </div>
      <div class="address flex column">
        <span>{{'Location.Labels.Address' | translate}}</span>
        <p>{{location.address}}</p>
      </div>
    </div>
    <button
      *ngIf="!generalReceiver && ((type == LocationType.Customer && (RolesConstants.CUSTOMER_EDIT | userRoleChecker)) || (type == LocationType.Fleet && (RolesConstants.FLEET_EDIT | userRoleChecker)) || (type == LocationType.Receiver && (RolesConstants.GLOBAL_RECEIVER_EDIT | userRoleChecker)))"
      class="button flex align-center justify-center"
      (click)="selectedLocation = {}; matDialog.open(addLocationModal)"
    >
      <img src="../../../../../assets/images/add.svg" />
      <span *ngIf="locations?.length">{{'Location.AddMoreLocations' | translate}}</span>
      <span *ngIf="!locations?.length">{{'Location.AddLocation' | translate}}</span>
    </button>
  </div>
</div>

<ng-template #addLocationModal>
  <app-dialog-layout class="dialog-layout madar--v2">
    <ng-container dialog-title>{{ (selectedLocation?.id ? 'Location.EditLocation' : 'Location.AddLocation') | translate }}</ng-container>
    <div dialog-content class="mt-3">
        <app-add-location
        (closeModal)="matDialog.closeAll()"
        (updatedLocation)="onUpdateLocation($event)"
        (locationId)="onAddLocation($event)"
        [item]="item"
        [location]="selectedLocation"
        [type]="type"
        ></app-add-location>
    </div>
  </app-dialog-layout>
</ng-template>
